import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gradient-to-br from-gray-100 to-white text-gray-800 py-12 border-t border-gray-300">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 px-6">
        <div className="max-w-md">
          <img src="/assets/logos/logo-dark.png" alt={t("common.logoAlt")} className="h-12 mb-4" />
          <p className="text-gray-700 leading-relaxed">{t("footer.description")}</p>
        </div>

        <div>
          <h3 className="text-lg font-bold text-gray-900 mb-3">{t("footer.quickLinks")}</h3>
          <ul className="space-y-2">
            <li>
              <a href="/" className="hover:text-yellow-500 transition">
                {t("navbar.home")}
              </a>
            </li>
            <li>
              <a href="/services" className="hover:text-yellow-500 transition">
                {t("navbar.services")}
              </a>
            </li>
            <li>
              <a href="/blog" className="hover:text-yellow-500 transition">
                {t("navbar.blog")}
              </a>
            </li>
            <li>
              <a href="/contact" className="hover:text-yellow-500 transition">
                {t("navbar.contact")}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-bold text-gray-900 mb-3">{t("footer.contact")}</h3>
          <p className="text-gray-700">
            {t("footer.email")}: info@ir-accounting.ca
          </p>
          <p className="text-gray-700">
            {t("footer.phone")}: +1 (647) 906-7308
          </p>
        </div>

        <div>
          <h3 className="text-lg font-bold text-gray-900 mb-3">{t("footer.followUs")}</h3>
          <div className="flex space-x-4">
            <a
              href="https://www.facebook.com/profile.php?id=61573193909629"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-yellow-500 transition text-xl"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-yellow-500 transition text-xl"
            >
              <FaInstagram />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-yellow-500 transition text-xl"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      <div className="text-center mt-8 text-gray-600 text-sm">
        © {new Date().getFullYear()} Iryna Romaniuk Accounting Services. {t("footer.rightsReserved")}
      </div>
    </footer>
  );
};

export default Footer;
